import Demandes from '@/views/gpao/demande_transfert/pages/Demande';
import Create from '@/views/gpao/demande_transfert/pages/DemandeCreate';
import Edit from '@/views/gpao/demande_transfert/pages/DemandeEdit';
import Show from '@/views/gpao/demande_transfert/pages/DemandeShow';

export default [
  {
    path: '/gpao/demande-transfert',
    name: 'gpao_demande_transfert',
    component: Demandes,
    meta: {
      auth: true,
      module: 'gpao',
      permission: 'view demande-transfert',
    },
  },
  {
    path: '/gpao/demande-transfert/create/:cloneId?',
    name: 'gpao_demande_transfert-create',
    component: Create,
    meta: {
      auth: true,
      module: 'gpao',
      permission: 'create demande-transfert',
    },
  },
  {
    path: '/gpao/demande-transfert/edit/:id',
    name: 'gpao_demande_transfert-edit',
    component: Edit,
    meta: {
      auth: true,
      module: 'gpao',
      permission: 'edit demande-transfert',
    },
  },
  {
    path: '/gpao/demande-transfert/show/:id',
    name: 'gpao_demande_transfert-show',
    component: Show,
    meta: {
      auth: true,
      module: 'gpao',
      permission: 'view demande-transfert',
    },
  },
];
